import { AnimatedComponent } from 'sane-ui'
import { SplitText } from 'gsap/all'

class Title extends AnimatedComponent {
  constructor ($el, args) {
    args.offset = '95%'
    super($el, args)
  }

  buildTimelineIn () {
    let data = this.$el.data()

    data = Object.assign(
      { type: 'c' },
      data
    )

    let st

    this.timelineIn
      .set(this.$el, { autoAlpha: 1 })

    // Revert split text upon resize.
    $(document.body)
      .on(
        'Components/ready',
        () => {
          $(window).one('resize', () => {
            st.revert()
          })
        }
      )

    switch (data.type) {
      // Characters
      case 'c':
        st = new SplitText(this.$el, { type: 'chars,words' })

        this.timelineIn
          .from(st.chars, { duration: 0.5, opacity: 0, ease: 'none', stagger: 0.025 }, 0)
          .from(st.chars, { duration: 0.5, x: '80%', ease: 'power3.out', stagger: 0.025 }, 0)
        break
      case 'lc':
        st = new SplitText(this.$el, { type: 'chars,lines,words', charsClass: 'st-char', wordsClass: 'st-word' })

        st.lines.forEach((line, index) => {
          const $lineChars = $(line).find('.st-char')
          this.timelineIn
            .from($lineChars, { duration: 0.5, opacity: 0, ease: 'none', stagger: 0.025 }, index * 0.125)
            .from($lineChars, { duration: 0.5, x: '80%', ease: 'power3.out', stagger: 0.025 }, index * 0.125)
        })
        break
      case 'w':
        st = new SplitText(this.$el, { type: 'words' })

        this.timelineIn
          .from(
            st.words,
            { duration: 1.2, opacity: 0, ease: 'none', stagger: 0.01 },
            0
          )
          .from(
            st.words,
            { duration: 0.6, y: '20%', ease: 'power2.out', stagger: 0.01 },
            0
          )
        break
      default:
        break
    }
  }
}

export default Title



// WEBPACK FOOTER //
// ./scripts/components/animation/Title.js